module.exports = __webpack_public_path__ + "static/DRITAN-ebc898ba201fb53d441d4f8a10205688.svg";